import React from 'react';
import { useProfile } from '../../contexts/ProfileContext';

/**
 * IntroStep — the index-0 step of the hjelpestønad wizard: the welcome text
 * and who this søknad is about.
 *
 * The child is fixed. It is picked on the overview (/soknad/:type) before the
 * draft exists, and a draft's answers stay with that child. A draft saved
 * without a subject (before the person picker) is the onboarded child's.
 */
export function IntroStep({
  step,
  profile: profileProp, // optional injection for testing; falls back to context
  subject,
  onAdvance,
}) {
  const profileCtx = useProfile();
  const profile = profileProp ?? profileCtx?.profile;
  const childName = subject?.subjectName
    || (subject?.subjectIsOnboardedChild !== false ? profile?.child?.alias : null)
    || 'barnet ditt';

  return (
    <div>
      {/* Welcome header */}
      <h2 className="text-2xl font-semibold text-text-primary mb-3">
        {step.title}
      </h2>
      <p className="text-text-secondary mb-6 leading-relaxed whitespace-pre-line">
        {step.subtitle}
      </p>

      <div className="mb-8 bg-sage-50 border border-sage-200 rounded-xl p-4">
        <p className="text-sage-800">
          Denne søknaden handler om{' '}
          <span className="font-semibold">{childName}</span>.
        </p>
      </div>

      {/* Advance */}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onAdvance}
          className="
            inline-flex items-center gap-2
            px-8 py-3 rounded-xl
            bg-primary text-white font-semibold
            hover:bg-primary-600 hover:shadow-primary
            active:transform active:scale-95
            transition-all duration-200
          "
        >
          La oss begynne
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default IntroStep;
